import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Detail from './Detail';
import List from './List';

export default function NurseOperationPage() {
  return (
    <Switch>
      <Route path="/transactions/employee/:employeeId/nursing-actions" exact>
        <List />
      </Route>
      <Route path="/transactions/employee/:employeeId/nursing-actions/:nurseOperationId">
        <Detail />
      </Route>
    </Switch>
  );
}
